"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.context");

var _reactHelmet = require("react-helmet");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* que este se subscriba a seo y escriba verdad? */
class MetaData extends _react.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      seoInfo: null
    });

    _defineProperty(this, "componentDidMount", () => {
      const {
        projectId,
        seoCustomValue,
        pageId,
        pageWithExtraInfo
      } = this.props;
      const aliasFront = seoCustomValue || '{}';
      const {
        segment
      } = this.props;
      const reqData = {
        SEG_NAV: segment,
        location: `${pageId}`,
        customValues: aliasFront
      }; // preguntamos a context

      const match = this.props.match || null;
      const params = match && match.params || null;

      if (pageWithExtraInfo && match && params) {
        let myUrl = reqData.location;
        const paramsKeys = Object.keys(params);
        paramsKeys.forEach(key => {
          const value = params[key];
          myUrl = myUrl.replace(`:${key}`, value);
        });
        reqData.location = myUrl;
      }

      window.nookInfoExchange.sendMessage('SEO_PARAMS', reqData); // respuesta de context

      window.nookInfoExchange.registerAsObserver(_gerenciatdUtils.QUEUE_NAMES.SEO_DATA, `${projectId}-SEO`, seoData => {
        window.nookInfoExchange.cleanObserver(_gerenciatdUtils.QUEUE_NAMES.SEO_DATA, `${projectId}-SEO`);
        this.setState({
          seoInfo: seoData
        });
        this.props.onFinish(seoData);
      });
    });
  }

  render() {
    const {
      seoInfo
    } = this.state;

    if (!seoInfo) {
      return null;
    }

    const seoInfoKeys = seoInfo ? Object.keys(seoInfo) : [];

    if (seoInfoKeys.length === 0) {
      return null;
    }
    /* eslint-disable camelcase */


    const {
      /* basics first level values */
      title,
      description,
      keywords,
      robots,
      canonical
    } = seoInfo;
    /* modifications dates */

    const {
      dateModified,
      datePublished,
      dateCreated
    } = seoInfo;
    /* rrss_fb */

    const {
      rrss_fb
    } = seoInfo;
    const fbTitle = rrss_fb && rrss_fb['og:title'] ? rrss_fb['og:title'] : '';
    const fbType = rrss_fb && rrss_fb['og:type'] ? rrss_fb['og:type'] : '';
    const fbImage = rrss_fb && rrss_fb['og:image'] ? rrss_fb['og:image'] : '';
    const fbUrl = rrss_fb && rrss_fb['og:url'] ? rrss_fb['og:url'] : '';
    const fbDescription = rrss_fb && rrss_fb['og:description'] ? rrss_fb['og:description'] : '';
    const fbSiteName = rrss_fb && rrss_fb.site_name ? rrss_fb.site_name : '';
    /* x aki vamos */

    const {
      search_engines_verification
    } = seoInfo;
    /* microdata */

    const {
      microdata_product,
      microdata_website,
      breadcrums
    } = seoInfo;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHelmet.Helmet, {
      children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
        children: title
      }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "description",
        content: description
      }), keywords && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "keywords",
        content: keywords
      }), robots && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "Robots",
        content: robots
      }), canonical && /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
        rel: "canonical",
        href: canonical
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "author",
        content: "Movistar"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        name: "owner",
        content: "Movistar"
      }), dateModified && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        itemProp: "dateModified",
        content: dateModified
      }), datePublished && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        itemProp: "datePublished",
        content: datePublished
      }), dateCreated && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        itemProp: "dateCreated",
        content: dateCreated
      }), fbTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        property: "og:title",
        content: fbTitle
      }), fbImage && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        property: "og:image",
        content: fbImage
      }), fbType && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        property: "og:type",
        content: fbType
      }), fbUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        property: "og:url",
        content: fbUrl
      }), fbDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        property: "og:description",
        content: fbDescription
      }), fbSiteName && /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
        property: "og:site_name",
        content: "Movistar"
      }), search_engines_verification && search_engines_verification.length > 0 && search_engines_verification.map(item => {
        const keyName = Object.keys(item)[0] || '';
        const value = item[keyName] || '';
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
          name: keyName,
          content: value
        }, `${keyName}-${value}`);
      }), microdata_product && /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
        type: "application/ld+json",
        children: JSON.stringify(microdata_product)
      }), microdata_website && /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
        type: "application/ld+json",
        children: JSON.stringify(microdata_website)
      }), breadcrums && /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
        type: "application/ld+json",
        children: JSON.stringify(breadcrums)
      })]
    });
  }

}

var _default = MetaData;
exports.default = _default;

//# sourceMappingURL=MetaData.js.map